import {cx} from "emotion";
import * as React from "react";
import "./controls.scss";

export const Controls = ({cc}) => (
    cc.sides?.length > 1 ? <div className="controls controls-2p3">
        <div className="buttons">
            {cc.sides?.map((sideName, i) => (
                <button
                    key={i}
                    className={cx(sideName === cc.currentSide && "selected")}
                    onClick={() => cc.changeSide(i, cc.editing)}
                    xd-qa-type="button"
                    xd-qa-name={sideName}
                >
                    {sideName}
                </button>
            ))}

        </div>
    </div> : <></>
);